<template>
  <ComponenteCatalogoAtivo :titulo="'externo'" />
</template>

<script>
import ComponenteCatalogoAtivo from "../components/ComponenteCatalogoAtivo.vue";

export default {
  components: {
    ComponenteCatalogoAtivo,
  },
  setup() {
    return {};
  },
};
</script>
